import { createContext, useContext, type ReactNode } from "react";

export type HeadStore = {
  title?: string;
  description?: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  noindex?: boolean;
  jsonLd: object[];
};

export function createHeadStore(): HeadStore {
  return { jsonLd: [] };
}

const HeadCtx = createContext<HeadStore | null>(null);

export function HeadProvider({
  store,
  children,
}: {
  store: HeadStore;
  children: ReactNode;
}) {
  return <HeadCtx.Provider value={store}>{children}</HeadCtx.Provider>;
}

export function useHeadStore(): HeadStore | null {
  return useContext(HeadCtx);
}
